var _path, _path2, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.13623 9.3149C4.13623 6.30244 6.57831 3.86035 9.59078 3.86035H16.7683C18.0069 3.86035 19.2086 4.28188 20.1758 5.05561L21.7331 6.30145C22.7002 7.07518 23.9019 7.49672 25.1405 7.49672H31.409C34.4214 7.49672 36.8635 9.9388 36.8635 12.9513V20.224C36.8635 23.2365 34.4214 25.6785 31.409 25.6785H9.59077C6.57831 25.6785 4.13623 23.2365 4.13623 20.224V9.3149Z",
    fill: "#101010"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04532 9.3149C5.04532 6.80451 7.08039 4.76944 9.59078 4.76944H16.7683C17.8005 4.76944 18.8019 5.12072 19.6079 5.76549L21.1652 7.01133C22.2935 7.91402 23.6955 8.40581 25.1405 8.40581H31.409C33.9193 8.40581 35.9544 10.4409 35.9544 12.9513V20.224C35.9544 22.7344 33.9193 24.7694 31.409 24.7694H9.59077C7.08039 24.7694 5.04532 22.7344 5.04532 20.224V9.3149Z",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 1.81818
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.13623,
    y: 12.9512,
    width: 32.7273,
    height: 23.6364,
    rx: 5.45455,
    fill: "#101010"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.04532,
    y: 13.8603,
    width: 30.9091,
    height: 21.8182,
    rx: 4.54545,
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 1.81818
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.102e5e7d648a7f494d943ddeb2847af8.svg";
export { ForwardRef as ReactComponent };